import React from 'react';
import { motion } from 'framer-motion';

export default function Loader() {
    return (
        <div className="loader-overlay">
            <motion.div
                className="loader-spinner"
                animate={{ rotate: 360 }}
                transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
            />
        </div>
    );
}